import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Providers } from '@/providers'
import { router } from '@/router'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element #root not found in index.html')

createRoot(rootElement).render(
    <StrictMode>
        <Providers>
            <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </Providers>
    </StrictMode>
)
